import React from "react";
import Heading from "../utils/Heading";
import "../styles/tech.css";
import TechCard from "../utils/TechCard";

// import frontendImg from '../assets/frontend.png';
// import backendImg from '../assets/backend.png';
// import databaseImg from '../assets/database.png';
// import languagesImg from '../assets/languages.png';
// import toolsImg from '../assets/tools.png';

import {
  frontend,
  backend,
  databases,
  tests,
  css
} from "../constants/techdata";

function TechCardData(tech: any) {
  return <TechCard name={tech.name} logo={tech.logo} />;
}

const Tech = () => {
  return (
    <div className="section tech">
      <div className="wrapper d-flex justify-content-center align-items-center">
        <div className="" id="tech">
          <div className="column">
            <Heading heading={"MY TECH STACK"} />
            <div className="techcards-list">
              <div className="rowTech">
                <div className="TechCard p-2 mb-2">
                  <p className="tech">FRONTEND</p>
                  <div className="container">
                    <div className="rowTech">
                      <div className="column">
                        {frontend.map((techItem: any) => (
                          <TechCardData {...techItem} key={techItem.id} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rowTech">
                <div className="TechCard p-2 mb-2">
                  <p className="tech">BACKEND</p>
                  <div className="container">
                    <div className="rowTech">
                      <div className="column">
                        {backend.map((techItem: any) => (
                          <TechCardData {...techItem} key={techItem.id} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rowTech">
                <div className="TechCard p-2 mb-2">
                  <p className="tech">CSS LIBRARIES</p>
                  <div className="container">
                    <div className="rowTech">
                      <div className="column">
                        {css.map((techItem: any) => (
                          <TechCardData {...techItem} key={techItem.id} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rowTech">
                <div className="TechCard p-2 mb-2">
                  <p className="tech">DATABASES</p>
                  <div className="container">
                    <div className="rowTech">
                      <div className="column">
                        {databases.map((techItem: any) => (
                          <TechCardData {...techItem} key={techItem.id} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rowTech">
                <div className="TechCard p-2 mb-2">
                  <p className="tech">TESTING</p>
                  <div className="container">
                    <div className="rowTech">
                      <div className="column">
                        {tests.map((techItem: any) => (
                          <TechCardData {...techItem} key={techItem.id} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Tech;
